import { render, staticRenderFns } from "./OfertConfirm.vue?vue&type=template&id=c22567f0&scoped=true"
import script from "./OfertConfirm.vue?vue&type=script&lang=js"
export * from "./OfertConfirm.vue?vue&type=script&lang=js"
import style0 from "./OfertConfirm.vue?vue&type=style&index=0&id=c22567f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22567f0",
  null
  
)

export default component.exports